class OscNode extends Weaver.Node

  @className = 'Oscillator'

  constructor: (id) ->
    super(id)

  create: (name = "New Oscillator", freq = 440, waveType = 'sine') ->
    type = await Weaver.Node.firstOrCreate('Oscillator')
    @set('name', name)
    @set('freq', freq)
    @set('waveType', waveType)
    @relation('type').add(type)
    @save()

export default OscNode
